import { Container, IconButton, Toolbar, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { StaticIcon } from 'web-components-ts';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { FOOTER_NAVIGATION_BAR_HEIGHT, NAVIGATION_BAR_HEIGHT } from '../../../attrs/layout';
import RequestPasswordResetForm from '../../../components/forms/Auth/RequestPasswordResetForm';
import { AppBarContentWrapper, StyledAppBar } from '../../../elements';
import { isSuccess } from '../../../helpers/utils';
import { getRequestPasswordReset } from '../../../redux/auth/selectors';

const RequestPasswordReset = () => {
  const { status } = useSelector(getRequestPasswordReset);
  const { t } = useTranslation();

  return (
    <>
      <StyledAppBar position="fixed">
        <Toolbar variant="dense">
          <IconButton edge="start" color="inherit" aria-label="back" href="/login">
            <ChevronLeftIcon />
          </IconButton>
          <AppBarContentWrapper center>
            <StaticIcon name="NotifyLogoFull" sx={{ fontSize: 60 }} />
          </AppBarContentWrapper>
          <div style={{ width: '48px' }} />
        </Toolbar>
      </StyledAppBar>
      {isSuccess(status) ? (
        <Container
          maxWidth="sm"
          style={{
            marginTop: NAVIGATION_BAR_HEIGHT,
            paddingTop: '2rem'
          }}
        >
          <Typography variant="body1">{t('auth.request_password_sent_email')}</Typography>
        </Container>
      ) : (
        <Container
          maxWidth="sm"
          style={{
            marginTop: NAVIGATION_BAR_HEIGHT,
            paddingTop: '3rem',
            paddingBottom: `${FOOTER_NAVIGATION_BAR_HEIGHT + 20}px`
          }}
        >
          <Typography variant="subtitle2" color="textSecondary" style={{ marginBottom: '1.5rem' }}>
            {t('auth.request_password_sub_title')}
          </Typography>
          <RequestPasswordResetForm />
        </Container>
      )}
    </>
  );
};

export default RequestPasswordReset;
